import { useEffect, useState } from 'react';
import { getLargestUnitOfTimeOfDurationWithLabel } from '../../common/helpers/utils';

export function useTimeToUpdate(
    unitStatusUpdatedDateParsed: Date | number | undefined,
    delay: number,
    timeUpdateKey?: string
): string | undefined {
    const [timeToShow, setTimeToShow] = useState('');

    useEffect(() => {
        if (!unitStatusUpdatedDateParsed) {
            return undefined;
        }
        const updateTimeToShow = () => {
            setTimeToShow(
                getLargestUnitOfTimeOfDurationWithLabel({
                    start: unitStatusUpdatedDateParsed,
                    end: new Date(),
                })
            );
        };

        updateTimeToShow();

        const interval = setInterval(() => {
            updateTimeToShow();
        }, delay);
        return () => {
            clearInterval(interval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeUpdateKey]);

    return unitStatusUpdatedDateParsed ? timeToShow : undefined;
}
